<label class="col-form-label" *ngIf="label" for="">{{label}}</label>

<span class="checkbox form-control-plaintext" [ngClass]="[size, 'text-' + color]" (click)="internalClick()">
    <fa-icon *ngIf="!value" [icon]="['far', 'square']" [ngClass]="{'text-muted': disabled}"></fa-icon>
    <fa-icon *ngIf="value" [icon]="['far', 'check-square']" [ngClass]="{'text-muted': disabled}"></fa-icon>
</span>
